/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Previous_Event_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Previous Event" |
*
* @param {Player_Previous_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_previous_event_aria_label = /** @type {((inputs?: Player_Previous_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Previous_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Evenement Precedent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorheriges Ereignis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evento precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предыдущее событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上一活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前回のイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछला कार्यक्रम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento anterior")
	return /** @type {LocalizedString} */ ("Previous Event")
});